import { headerBgGradientAngle } from './HeaderBgStore';

import { headerBgGradientAngleDefault } from './HeaderBgStoreDefaults';

export const resetHeaderBgGradientAngle = () => headerBgGradientAngle.set(headerBgGradientAngleDefault);
